import React from 'react'
import cx from 'classnames'
import styles from './SecondaryTabsBar.module.scss'
import { SecondaryTab } from './SecondaryTab/SecondaryTab'

type SecondaryTabsBarProps = {
  activeTab
  className?: string
  tabClassName?: string
  iconClassName?: string
  tabs
  setActiveTab
}

export const SecondaryTabsBar = ({
  activeTab,
  className,
  tabClassName,
  iconClassName,
  tabs,
  setActiveTab,
}: SecondaryTabsBarProps) => {
  const tabWidth = Math.round((100 / tabs.length) * 10) / 10
  const indicatorTransition =
    tabs.findIndex(tab => tab?.id === activeTab) * tabWidth

  return (
    <div className={cx(styles.tabs, className)}>
      <div className={styles.tabsContainer}>
        {tabs.map(
          ({ id, label, isDisabled = false, icon, caution = 0 }, index) => (
            <SecondaryTab
              key={id}
              {...{
                id,
                icon,
                label,
                caution,
                isDisabled,
                setActiveTab,
                tabClassName,
                iconClassName,
                isActiveTab: activeTab === id,
              }}
            />
          ),
        )}
      </div>

      <div
        className={styles.indicator}
        style={{
          [`--width`]: `${tabWidth}%`,
          [`--left`]: `${indicatorTransition}%`,
        }}
      ></div>
    </div>
  )
}
